import { render, staticRenderFns } from "./contentLectureExam.vue?vue&type=template&id=284a3feb&"
import script from "./contentLectureExam.vue?vue&type=script&lang=js&"
export * from "./contentLectureExam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports